import { useEffect, useState } from "react";

import {
  ListContainer,
  ListContext,
  Page,
  PageRoute,
  SearchBar,
  Stack,
  buildPath,
  buildTemplatePath,
  pn,
} from "@compass/core";

import { ListFooter } from "components";
import {
  Permission,
  StudentApplicationListDto,
  StudentApplicationListFilter,
  StudentApplicationListResource,
  StudentApplicationFilter as StudentApplicationFilterModel,
  StudentFileListDto,
} from "generated/openApi";
import { useInitListFilter, useList, useListFilter } from "hooks";
import produce from "immer";
import { Outlet, useNavigate } from "react-router-dom";
import ApiService from "services/apiService";
import { StudentFileFilter } from "./StudentFileFilter";
import { StudentFileTable } from "./StudentFileTable";

const routeName = "studentFiles";

export const studentFileListPageRoute: PageRoute = {
  handle: "Files",
  templatePath: buildTemplatePath(routeName),
  getPath: () => buildPath(routeName),
};

export const StudentFileListPage = () => {
  const ROOT_PERMISSION: Permission = Permission.StudentFile;
  const navigate = useNavigate();

  const { listFilter, setListFilter } = useInitListFilter<StudentApplicationListFilter>({
    sortObjects: [{ property: pn<StudentApplicationListDto>("submittedDate"), isDesc: true }],
    groupFilter: {
      applicationStatuses: [1],
    },
  });

  const [initListFilter] = useState<StudentApplicationListFilter>(listFilter);
  const [listItems, setListItems] = useState<StudentFileListDto[]>([]);
  const [total, setTotal] = useState<number>();
  const [resource, setResource] = useState<StudentApplicationListResource>({});
  const [searchFocused, setSearchFocused] = useState<boolean>(false);

  // const {
  //   tableContainerRef,
  //   applyPage,
  //   applyPageSize,
  //   applySortMethod,
  //   applySort,
  //   applySearch,
  //   loadList,
  //   selectId,
  //   selectedIds,
  //   setSelectedIds,
  // } = useList({
  //   listFilter: listFilter,
  //   setListFilter: setListFilter,
  //   fetchList: (listFilter) => {
  //     ApiService.studentFiles.getCategorizedList(listFilter).then((response) => {
  //       setListItems(response);
  //     });
  //   },
  //   fetchTotal: (listFilter) => {
  //     setTotal(undefined);
  //     ApiService.studentFiles.getCategorizedListTotal(listFilter).then((response) => {
  //       setTotal(response);
  //     });
  //   },
  // });

  useEffect(() => {
    // loadList(listFilter);
    fetchResource();
  }, []);

  const fetchResource = () => {
    ApiService.studentApplications.getListResource().then((response) => {
      setResource(response);
    });
  };

  // const listFilterNode = useListFilter<StudentApplicationListFilter>({
  //   listFilter: listFilter,
  //   initListFilter: initListFilter,
  //   onApply: (listFilter) => loadList(listFilter, { resetPage: true }),
  //   inputNode: (listFilter, setListFilter) => (
  //     <StudentFileFilter
  //       filter={listFilter.groupFilter || ({} as StudentApplicationFilterModel)}
  //       setFilter={(filter) =>
  //         setListFilter(
  //           produce(listFilter, (draft) => {
  //             draft.groupFilter = filter;
  //           })
  //         )
  //       }
  //     />
  //   ),
  // });

  // const getIdsMethods = () => ApiService.studentApplications.getIds(listFilter);

  return (
    <>
      <Page header={studentFileListPageRoute.handle}>
        {/* <ListContainer
          fullHeight
          header={
            <Stack direction="row" justifyContent="space-between">
              <SearchBar onStoppedTyping={applySearch} setSearchFocused={setSearchFocused} size="small" />
              {listFilterNode}
            </Stack>
          }
          tableContainer={
            <StudentFileTable
              openNewTab={false}
              rootPermission={ROOT_PERMISSION}
              tableContainerRef={tableContainerRef}
              studentFiles={listItems}
              resource={resource}
              listTotal={total}
              sortObjects={listFilter.sortObjects}
              sort={applySort}
              searchFocused={searchFocused}
              selectId={selectId}
              selectedIds={selectedIds}
              setSelectedIds={setSelectedIds}
              getIdsPromise={() => getIdsMethods()}
            />
          }
          footer={
            <ListFooter
              total={total}
              size={listFilter.pageSize}
              page={listFilter.page}
              onPageChange={applyPage}
              onSizeChange={applyPageSize}
              onSortMethodChange={applySortMethod}
            />
          }
        /> */}
      </Page>

      <ListContext.Provider
        value={{
          // loadList: (options) => loadList(listFilter, { resetPage: options?.resetPage }),
          // clearSelectedIds: () => setSelectedIds([]),
        }}
      >
        <Outlet />
      </ListContext.Provider>
    </>
  );
};
